// Single source of truth for state availability.
// Edit `eligible: false` to add states where Olive hasn't launched yet.
export type State = { code: string; name: string; slug: string; eligible: boolean };

const RAW: Array<[string, string, boolean]> = [
  ["AL", "Alabama", true],
  ["AK", "Alaska", true],
  ["AZ", "Arizona", true],
  ["AR", "Arkansas", true],
  ["CA", "California", true],
  ["CO", "Colorado", true],
  ["CT", "Connecticut", true],
  ["DE", "Delaware", true],
  ["FL", "Florida", true],
  ["GA", "Georgia", true],
  ["HI", "Hawaii", false],
  ["ID", "Idaho", true],
  ["IL", "Illinois", true],
  ["IN", "Indiana", true],
  ["IA", "Iowa", true],
  ["KS", "Kansas", true],
  ["KY", "Kentucky", true],
  ["LA", "Louisiana", true],
  ["ME", "Maine", true],
  ["MD", "Maryland", true],
  ["MA", "Massachusetts", true],
  ["MI", "Michigan", true],
  ["MN", "Minnesota", true],
  ["MS", "Mississippi", true],
  ["MO", "Missouri", true],
  ["MT", "Montana", true],
  ["NE", "Nebraska", true],
  ["NV", "Nevada", true],
  ["NH", "New Hampshire", true],
  ["NJ", "New Jersey", true],
  ["NM", "New Mexico", true],
  ["NY", "New York", true],
  ["NC", "North Carolina", true],
  ["ND", "North Dakota", true],
  ["OH", "Ohio", true],
  ["OK", "Oklahoma", true],
  ["OR", "Oregon", true],
  ["PA", "Pennsylvania", true],
  ["RI", "Rhode Island", true],
  ["SC", "South Carolina", true],
  ["SD", "South Dakota", true],
  ["TN", "Tennessee", true],
  ["TX", "Texas", true],
  ["UT", "Utah", true],
  ["VT", "Vermont", true],
  ["VA", "Virginia", true],
  ["WA", "Washington", true],
  ["WV", "West Virginia", false],
  ["WI", "Wisconsin", true],
  ["WY", "Wyoming", false],
];

export const STATES: State[] = RAW.map(([code, name, eligible]) => ({
  code,
  name,
  slug: name.toLowerCase().replace(/\s+/g, "-"),
  eligible,
}));

export const ELIGIBLE_COUNT = STATES.filter((s) => s.eligible).length;
export const STATE_BY_SLUG = Object.fromEntries(STATES.map((s) => [s.slug, s]));
export const STATE_BY_CODE = Object.fromEntries(STATES.map((s) => [s.code, s]));
